import { deserialize } from 'cerialize'

export class SmsStatsModel {
	@deserialize public per_minute?: number
	@deserialize public per_hour?: number
	@deserialize public per_day?: number
	@deserialize public per_month?: number
	@deserialize public per_quarter?: number
	@deserialize public per_year?: number
	@deserialize public per_all_time?: number
}
